import { Global } from "@/global";
import { Filesystem } from "@/util/filesystem";
import { createSignal } from "solid-js";
import { createStore } from "solid-js/store";
import { createSimpleContext } from "./helper";
import path from "path";
export const {
  use: useKV,
  provider: KVProvider
} = createSimpleContext({
  name: "KV",
  init: () => {
    const [ready, setReady] = createSignal(false);
    const [store, setStore] = createStore();
    const filePath = path.join(Global.Path.state, "kv.json");
    Filesystem.readJson(filePath).then(x => {
      setStore(x);
    }).catch(() => {}).finally(() => {
      setReady(true);
    });
    const result = {
      get ready() {
        return ready();
      },
      get store() {
        return store;
      },
      signal(name, defaultValue) {
        if (store[name] === undefined) setStore(name, defaultValue);
        return [function () {
          return result.get(name);
        }, function setter(next) {
          result.set(name, next);
        }];
      },
      get(key, defaultValue) {
        return store[key] ?? defaultValue;
      },
      set(key, value) {
        setStore(key, value);
        Filesystem.writeJson(filePath, store);
      }
    };
    return result;
  }
});